module.exports = __webpack_public_path__ + "img/avatar-s-14.jpg";